<template>
  <v-container class="py-10 py-md-13 py-lg-16">
    <PropertiesFiltersWidget v-bind="$props" />
    <LoadingWidget v-if="loading" />

    <transition name="fade">
      <div v-if="!loading" class="mt-8 mt-md-12">
        <div v-if="items.length" class="justify-center grid-list">
          <template v-for="(item, keyItems) in items">
            <div :key="keyItems" class="grid-list-item">
              <PropertyCard v-bind="item" />
            </div>
          </template>
        </div>

        <div v-else>
          <v-alert color="secondary" type="info" width="100%">
            Nenhum imóvel encontrado.
          </v-alert>

          <div v-if="Object.keys(filters).length !== 0" class="text-center">
            <v-btn class="secondary--text" color="white" :to="path" depressed>
              Todos os Imóveis
            </v-btn>
          </div>
        </div>

        <v-pagination
          v-if="pagesLength > 1"
          class="mt-10"
          color="secondary"
          :total-visible="mobile ? 3 : 10"
          v-model="page"
          :length="pagesLength"
        ></v-pagination>
      </div>
    </transition>
  </v-container>
</template>

<script>
import PropertiesFiltersWidget from "../components/widgets/PropertiesFiltersWidget.vue";
import LoadingWidget from "../components/widgets/LoadingWidget.vue";
import PropertyCard from "../components/cards/PropertyCard.vue";
import { formatToURL } from "../utils/formatToURL";

const _config = {
  mod: "properties",
  itemsPerPage: 12,
  returnTotalItems: 1,
};

export default {
  props: {
    business: {
      type: Number,
      required: true,
    },
  },
  data: () => ({
    loading: true,
    items: [],
    totalItems: 0,
  }),
  created() {
    this.getList();
  },
  computed: {
    path() {
      return this.business === 1 ? "/alugar" : "/comprar";
    },
    page: {
      get() {
        const p = this.$route.query.p;
        return p ? parseInt(p) : 1;
      },
      set(v) {
        const query = { ...this.$route.query };
        query.p = v;

        return this.$router.push({ query });
      },
    },
    pagesLength() {
      return Math.ceil(this.totalItems / _config.itemsPerPage);
    },
    filters() {
      return this.$route.query;
    },
    mobile() {
      return this.$vuetify.breakpoint.smAndDown;
    },
  },
  methods: {
    getList() {
      clearTimeout(this.getListTimer);

      this.getListTimer = setTimeout(() => {
        this.loading = true;

        const params = {
          itemsPerPage: _config.itemsPerPage,
          returnTotalItems: _config.returnTotalItems,
          page: this.page,
          business: this.business,
        };

        if (this.filters.t) params.category = this.filters.t;
        if (this.filters.b) params.city = this.filters.b;
        if (this.filters.d) params.district = this.filters.d;
        if (this.filters.c) params.reference = this.filters.c;
        if (this.filters.pl) params.garage = this.filters.pl;
        if (this.filters.r) params.bedroom = this.filters.r;
        if (this.filters.amin) params.minArea = this.filters.amin;
        if (this.filters.amax) params.maxArea = this.filters.amax;
        if (this.filters.bmin) params.minBuildingArea = this.filters.bmin;
        if (this.filters.bmax) params.maxBuildingArea = this.filters.bmax;
        if (this.filters.pmin) params.minPrice = this.filters.pmin;
        if (
          this.filters.pmax &&
          this.filters.pmax < (this.business === 1 ? 15000 : 5000000)
        )
          params.maxPrice = this.filters.pmax;

        this.$rest(_config.mod)
          .get({ params })
          .then((data) => {
            let items = [];
            if (_config.returnTotalItems) {
              items = data.list;
              this.totalItems = data.totalItems;
            } else {
              items = data;
            }

            this.items = items.map(
              ({
                id,
                title,
                img,
                reference,
                price,
                garage,
                bedrooms,
                pool,
                area,
                total_area,
                suites,
              }) => ({
                img,
                title,
                price,
                reference,
                details: [
                  {
                    icon: "fas fa-bed",
                    text:
                      Number(bedrooms) > 0 || Number(suites) > 0
                        ? Number(bedrooms) + Number(suites)
                        : 0,
                  },
                  {
                    icon: "fas fa-car",
                    text: Number(garage) > 0 ? Number(garage) : 0,
                  },
                  {
                    icon: "fas fa-swimmer",
                    text: Number(pool) > 0 ? Number(pool) : 0,
                  },
                  {
                    icon: "fas fa-home",
                    text: parseFloat(area) > 0 ? `${area}m²` : 0,
                  },
                  {
                    icon: "fas fa-expand-arrows-alt",
                    text: parseFloat(total_area) > 0 ? `${total_area}m²` : 0,
                  },
                ],
                to: this.path + `/${formatToURL(title)}-${id}`,
              })
            );
          })
          .then(() => (this.loading = false));
      }, 500);
    },
  },
  watch: {
    $route() {
      this.getList();
    },
  },
  components: {
    PropertiesFiltersWidget,
    LoadingWidget,
    PropertyCard,
  },
};
</script>

<style lang="scss" scoped>
.grid-list {
  display: grid;
  gap: 30px;
  grid-template-columns: repeat(3, 1fr);

  @media screen and (max-width: 960px) {
    grid-template-columns: 1fr 1fr;
  }

  @media screen and (max-width: 600px) {
    grid-template-columns: 1fr;
  }
}
</style>
